var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinicon = function SvgPinicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.773 12.023-3.182 3.182a2.25 2.25 0 0 1-3.18 0l-3.184-3.182a6.75 6.75 0 1 1 9.546 0ZM7 9.5A2.25 2.25 0 1 0 7 5a2.25 2.25 0 0 0 0 4.5Z",
    fill: "#47516E"
  })));
};
export default SvgPinicon;